import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import loadNotFound from './loadNotFound.gql'
import NotFound from '../../components/pages/NotFound'
import { homePageUrl, enableContentful as enableContentfulFromConfig } from '../../config'

const NotFoundContainer = (props) => {
  const { data, globalContent, globalComponents, ConfigContxt = {} } = props

  const { contentfulHeader, contentfulGlobalSettings, variables: { enableContentful } } = data

  if (data?.loading) {
    return null
  }
  if (!data?.loading && data?.error && !enableContentful) {
    return data.error
  }

  let notFoundPage = null
  let notFoundGlobalContent = globalContent
  let notFoundGlobalComponents = globalComponents

  if (enableContentful) {
    notFoundPage = data?.contentfulPage

    notFoundGlobalContent = {
      menuItems: contentfulHeader?.menuItems,
      dropdownMenu: contentfulHeader?.dropdownMenu,
      ...contentfulGlobalSettings
    }

    notFoundGlobalComponents = {
      components: {
        DynamicHeader: {
          globalConfig: contentfulHeader?.header
        }
      }
    }
  } else {
    notFoundPage = data?.pageOrGame?.page
  }

  return (
    <NotFound
      components={notFoundPage?.components}
      globalContent={notFoundGlobalContent}
      globalComponents={notFoundGlobalComponents}
      ConfigContxt={ConfigContxt}
      enableContentful={enableContentful}
    />
  )
}

NotFoundContainer.propTypes = {
  data: PropTypes.object,
  globalComponents: PropTypes.object,
  globalContent: PropTypes.object,
  ConfigContxt: PropTypes.object,
  components: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      props: PropTypes.object
    })
  ),
  enableContentful: PropTypes.bool
}

export default graphql(loadNotFound, {
  options: (props) => {
    const { location } = props
    const urlParams = new URLSearchParams(location?.search)

    const enableContentfulOverride = urlParams.get('enableContentful') === 'true'

    const enableContentful = urlParams.get('enableContentful') !== null ? enableContentfulOverride : enableContentfulFromConfig

    let path = `${homePageUrl}not-found`

    // Pages in contentful does not use leading slash for page key: uk/page
    if (homePageUrl.startsWith('/')) {
      path = path.substring(1)
    }

    return { variables: { path, enableContentful } }
  }
})(NotFoundContainer)
